<template>
  <div v-if="showCommunicationChannelState">
    <vs-row class="ml-4">
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
        <span class="sdf-text-16-700-white ml-4 whitespace-no-wrap">{{
          displayCommunicationChannelString
        }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="6">
        <img v-if="connectingState4gVSAT && connectingState4gVSAT.isDisconnect" :src="disconnectedIcon" width="25px" height="25px" />
        <img v-else-if="isVSAT" :src="icon" width="25px" height="25px" />
        <feather-icon
          v-else
          icon="WifiIcon"
          svg-classes="h-9 w-9 text-white"
        ></feather-icon>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
// mixins
import {
  MappingTableMixin,
  StoreCommonsMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [
    MappingTableMixin,
    StoreCommonsMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {},
  data() {
    return {
      icon: require("@/assets/images/icons/lolcal/satellite.svg"),
      disconnectedIcon: require("@/assets/images/icons/lolcal/wifi_off.svg")
    };
  },
  watch: {},
  computed: {
    showCommunicationChannelState() {
      return this.channelDataAlert !== null;
    },
    communicationChannel() {
      if (this.channelDataAlert.EX_AL_004) {
        return this.channelDataAlert.EX_AL_004.vs;
      } else {
        return this.noneValue;
      }
    },
    isVSAT() {
      if (this.channelDataAlert.EX_AL_004) {
        return this.channelDataAlert.EX_AL_004.vs === "VSAT";
      } else {
        return false;
      }
    },
    displayCommunicationChannelString() {
      if (this.connectingState4gVSAT && this.connectingState4gVSAT.isDisconnect) {
        return "圏外"
      } else {
        return this.communicationChannel
      }
    }
    
  },
  methods: {},
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss"></style>
